var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover-date d-flex direction-column ai-center radius-10 p-3"},[_c('small',[_vm._v(_vm._s(_vm.weekDay))]),_c('span',{staticClass:"font-size-1-3"},[_vm._v(_vm._s(_vm.monthDay))]),_c('small',[_vm._v(_vm._s(_vm.month))])])
}
var staticRenderFns = []

export { render, staticRenderFns }